'use strict';
import {combineReducers} from 'redux';
import {
  NAV_ASSET_LIST_NAME,
  NAV_ASSET_PROJECT_LIST_NAME,
  NAV_ORGANIZATION_LIST_NAME,
  NAV_PROJECT_LIST_NAME,
} from '../redux/state';
import {reduxList as assetsReduxList} from '../redux/assets';
import {reduxList as assetProjectsReduxList} from '../redux/assetProjects';
import {reduxList as organizationsReduxList} from '../redux/organizations';
import {reduxList as projectsReduxList} from '../redux/projects';

export * from './state';

export const appNavigation = combineReducers({
  [NAV_ASSET_LIST_NAME]: assetsReduxList.reducers.reducer,
  [NAV_ASSET_PROJECT_LIST_NAME]: assetProjectsReduxList.reducers.reducer,
  [NAV_ORGANIZATION_LIST_NAME]: organizationsReduxList.reducers.reducer,
  [NAV_PROJECT_LIST_NAME]: projectsReduxList.reducers.reducer,
});



// WEBPACK FOOTER //
// ./src/js/app/navigation/reducers/index.js